import { render, staticRenderFns } from "./FieldType11Configure.vue?vue&type=template&id=cb6f04ae&scoped=true"
import script from "./FieldType11Configure.vue?vue&type=script&lang=js"
export * from "./FieldType11Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f04ae",
  null
  
)

export default component.exports